import { render } from "./BoosterShop.vue?vue&type=template&id=7663adf9&scoped=true"
import script from "./BoosterShop.vue?vue&type=script&lang=js"
export * from "./BoosterShop.vue?vue&type=script&lang=js"

import "./BoosterShop.vue?vue&type=style&index=0&id=7663adf9&language=scss&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7663adf9"]])

export default __exports__